"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortedData = exports.getFilteredData = void 0;
/**
 * Utility to filter SearchableTable data based on a given query string
 * Handles basic searching and column:value syntax
 *
 * @param query Input query string
 * @param data  Raw data prop passed to SearchableTable to be filtered
 * @param labelKeyMap Table column labels/headers to object key map prop
 *
 * @returns data prop filtered to objects that contain at least one value which includes the query
 */
function getFilteredData(query, data, labelKeyMap) {
    const parsedQuery = query.toLowerCase();
    if (parsedQuery.includes(":")) {
        const splitQuery = parsedQuery.split(":");
        const columnLabel = splitQuery[0];
        const value = splitQuery[1];
        let key = labelKeyMap[columnLabel.toUpperCase()];
        if (labelKeyMap[columnLabel]) {
            key = labelKeyMap[columnLabel];
        }
        if (!key) {
            return [];
        }
        return data.filter(row => {
            if (row[key] === null || row[key] === undefined) {
                return false;
            }
            let parsedValue = row[key];
            if (typeof parsedValue === "object") {
                parsedValue = parsedValue.value;
            }
            if (typeof parsedValue !== "string") {
                parsedValue = parsedValue.toString();
            }
            return parsedValue.toLowerCase().includes(value);
        });
    }
    return data.filter(row => {
        for (const key of Object.keys(row)) {
            if (row[key] === null || row[key] === undefined) {
                continue;
            }
            let parsedValue = row[key];
            if (typeof parsedValue === "object") {
                parsedValue = parsedValue.value;
            }
            if (typeof parsedValue !== "string") {
                parsedValue = parsedValue.toString();
            }
            if (parsedValue.toLowerCase().includes(parsedQuery)) {
                return true;
            }
        }
        return false;
    });
}
exports.getFilteredData = getFilteredData;
/**
 * Utility to sort SearchableTable data by a specified column
 *
 * @param columnKey Column to sort on
 * @param data  Raw data prop passed to SearchableTable to be sorted
 * @param direction Number representing sorting direction where 1 = ascending, 0 = unsorted, -1 = descending
 *
 * @returns data prop sorted according to parameters
 */
function getSortedData(columnKey, data, direction) {
    if (direction === 0) {
        return data.slice();
    }
    return data.slice().sort((a, b) => {
        let parsedA = a[columnKey];
        let parsedB = b[columnKey];
        if (parsedA && parsedB) {
            if (typeof parsedA === "object" && typeof parsedB === "object") {
                parsedA = parsedA.value;
                parsedB = parsedB.value;
            }
        }
        else {
            if (parsedA && !parsedB) {
                return -1;
            }
            if (!parsedA && parsedB) {
                return 1;
            }
            return 0;
        }
        if (typeof parsedA === "string" && typeof parsedB === "string") {
            parsedA = parsedA.trim().toUpperCase();
            parsedB = parsedB.trim().toUpperCase();
        }
        if (direction === 1) {
            if (parsedA > parsedB) {
                return 1;
            }
            return -1;
        }
        else {
            if (parsedA < parsedB) {
                return 1;
            }
            return -1;
        }
    });
}
exports.getSortedData = getSortedData;
//# sourceMappingURL=helpers.js.map